<template>
  <CContainer :fluid="true" class='order-modal p-3'>
      <CRow>
          <CCol class='col-12 text-center'>
              <h2>Notificación de entrega</h2>
          </CCol>
          <CCol class='col-12'>
              <label for="textarea">Puede dejar aquí sus comentarios sobre la entrega:</label>
              <CTextarea :value.sync='message' placeholder='Mensaje (Opcional)'></CTextarea>
          </CCol>
          <CCol class='col-12'>
              <CRow class='d-flex justify-content-sm-end'>
                    <CCol class='col-12 col-sm-auto'>
                        <CButton color='success' @click="setDeliveredOrder(6)">
                            Entrega completa
                        </CButton>
                    </CCol>
                    <CCol class='col-12 col-sm-auto'>
                        <CButton color='warning' @click="setDeliveredOrder(7)">
                            Entrega parcial
                        </CButton>
                    </CCol>
                    <CCol class='col-12 col-sm-auto'>
                        <CButton color='danger' @click="closeModal">
                            Cancelar
                        </CButton>
                    </CCol>              
                </CRow>
          </CCol>
      </CRow>
      
  </CContainer>
</template>

<script>
export default {
    name: 'DeliveredOrderModal',
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            message: ''
        }
    },
    methods: {
        closeModal(){
            this.$root.$emit('close-modal')
        },
        setDeliveredOrder(order_status){
            const data = {
                delivered_order_status: order_status,
                order_id: this.order.id,
                message: this.message
            }
            this.$api.orders.setDeliveredOrder(data)
            .then(res => {
                this.$root.$emit('delivered-order');
            })
            .catch(error => {
                console.log(error)
            })
        }
    }
}
</script>

<style lang='scss'>
.order-modal{
    max-height: calc(100vh - 2rem);
    background-color: white;
    border-radius: 4px;
    max-width: 600px;
}
</style>